import { i18n } from '@fs/zion-locale'
import * as Yup from 'yup'

/**
 * Committing the picker while the filter matches nothing leaves the field with no selection.
 * A missing field is left to `required`.
 *
 * @param {Object} [value] - The relationship field's value.
 * @returns {boolean} Whether a relationship is selected.
 */
const hasSelection = (value) => value == null || Boolean(value?.selectedItem?.key)

// Use to validate the relationships form in the Relationships card
export const relationshipsValidationSchema = Yup.object().shape({
  household: Yup.object().nullable(),
  relationships: Yup.array().of(
    Yup.object().shape({
      relationship: Yup.object()
        .required(i18n.t('FormValidation.selectOption', 'Select an option from the list'))
        .test(
          'relationship-selected',
          i18n.t('FormValidation.selectOption', 'Select an option from the list'),
          hasSelection
        ),
    })
  ),
})
